import FirebaseClient from "../../logic/modules/FirebaseClient";
import { newGroupChat } from "./Action";
const FirebaseClientInstance = new FirebaseClient();

export const initializeFirebaseClient = (payload) => {
  return (dispatch) => {
    FirebaseClientInstance.init(payload);
  };
};

export const hideChatsLoading = (payload) => {
  return {
    type: "SET_HIDE_CHATS_LOADING",
    payload: payload,
  };
};
export const setUser = (user) => {
  FirebaseClientInstance.setUser(user);
};

export const trackEventActions = (eventName, payload) => {
  FirebaseClientInstance.trackEvent(eventName, payload);
};

export const getTokenActions = () => {
  return FirebaseClientInstance.getToken();
};

export const getGroupMessageHistory = (groupid, moreMsg) => {
  return async (dispatch, getState) => {
    let groupMsg = getState().groupsChats?.[groupid] ?? [];
    // console.log(groupid, groupMsg);
    let result = await FirebaseClientInstance.fetchMessage(
      groupid,
      groupMsg.length
    );
    // console.log(result);
    let lastMsgTimeStamp = groupMsg.length
      ? groupMsg[groupMsg.length - 1].createdat
      : null;
    // console.log(lastMsgTimeStamp);
    if (result === null) {
      dispatch(
        newGroupChat({
          groupid: [groupid],
          message: [],
          oldMessage: [],
        })
      );
      return;
    }
    let chatsArr = [];
    Object.keys(result).forEach((key) => {
      if (
        result[key].createdat <
        (lastMsgTimeStamp ? lastMsgTimeStamp : Date.now())
      ) {
        chatsArr.push(result[key]);
      }
    });
    chatsArr.sort((a, b) => {
      return b.createdat - a.createdat;
    });
    // console.log(chatsArr);

    dispatch(
      newGroupChat({
        groupid: [groupid],
        message: moreMsg ? [] : [...chatsArr],
        oldMessage: moreMsg ? [...chatsArr] : [],
      })
    );
    if (chatsArr.length < 100) {
      dispatch(hideChatsLoading({ groupid: [groupid] }));
    }
  };
};

export const uploadFileToCloud = async (file, fileType) => {
  return new Promise(async (res, rej) => {
    try {
      const url = await FirebaseClientInstance.uploadFile(
        file,
        
        fileType
      );
      res(url);
    } catch (e) {
      rej(e);
    }
  });
};
export const getDownloadableUrl = async (path) => {
  return new Promise(async (res, rej) => {
    try {
      const url = await FirebaseClientInstance.getUrl(path);
      res(url);
    } catch (e) {
      rej(e);
    }
  });
};
